
ko.bindingHandlers.checkableButton =
    init: (element, valueAccessor, allBindingsAccessor, viewModel) ->

        $(element).on 'click', () =>
            value = valueAccessor()
            val = ko.unwrap(value)

            value(not val)


        ko.utils.domNodeDisposal.addDisposeCallback element, () ->
            $(element).off 'click'



    update: (element, valueAccessor, allBindingsAccessor, viewModel) ->
        val = ko.unwrap(valueAccessor() ? {})

        if val
            $(element).removeClass("ko-checkableButton-unchecked")
        else
            $(element).addClass('ko-checkableButton-unchecked')
